export default [
  // {
  //   path: '/settings/registrationstages/list',
  //   name: 'registrationstages-list',
  //   component: () => import('@/views/setting/registrationstage/registrationstages-list/RegistrationStagesList.vue'),
  //   meta: {
  //     resource: 'Auth',
  //     action: 'read'
  //   },
  // },
  // {
  //   path: '/settings/bookingstages/list',
  //   name: 'bookingstages-list',
  //   component: () => import('@/views/setting/bookingstage/bookingstages-list/BookingStagesList.vue'),
  //   meta: {
  //     resource: 'Auth',
  //     action: 'read'
  //   },
  // },

  {
    path: '/settings/product-type/list',
    name: 'product-type-list',
    component: () => import('@/views/setting/product-type/listTab.vue'),
    meta: {
      action: 'read',
      resource: 'Auth'
    },
  },
  {
    path: "/settings/product-type/create",
    name: "product-type-create",
    component: () => import("@/views/setting/product-type/type/type-edit/typeEdit.vue"),
    meta: {
      action: "create",
      resource: "settings_product_type",
    },
  },
  {
    path: "/settings/product-type/edit/:id",
    name: "product-type-edit",
    component: () => import("@/views/setting/product-type/type/type-edit/typeEdit.vue"),
    meta: {
      action: "update",
      resource: "settings_product_type",
    },
  },
  {
    path: "/settings/product-unit/create",
    name: "product-unit-create",
    component: () => import("@/views/setting/product-type/unit/unit-edit/unitEdit.vue"),
    meta: {
      action: "create",
      resource: "settings_product_unit",
    },
  },
  {
    path: "/settings/product-unit/edit/:id",
    name: "product-unit-edit",
    component: () => import("@/views/setting/product-type/unit/unit-edit/unitEdit.vue"),
    meta: {
      action: "update",
      resource: "settings_product_unit",
    },
  },
  {
    path: "/settings/product-status/create",
    name: "product-status-create",
    component: () => import("@/views/setting/product-type/status/status-edit/statusEdit.vue"),
    meta: {
      action: "create",
      resource: "settings_product_status",
    },
  },
  {
    path: "/settings/product-status/edit/:id",
    name: "product-status-edit",
    component: () => import("@/views/setting/product-type/status/status-edit/statusEdit.vue"),
    meta: {
      action: "update",
      resource: "settings_product_status",
    },
  },

  {
    path: '/settings/receipt-format/list',
    name: 'receipt-format-list',
    component: () => import('@/views/setting/receipt-format/listTab.vue'),
    meta: {
      action: 'read',
      resource: 'settings_receipt_format'
    },
  },
  {
    path: "/settings/receipt-format/company/create",
    name: "receipt-format-company-create",
    component: () => import("@/views/setting/receipt-format/company/company-edit/companyEdit.vue"),
    meta: {
      action: "create",
      resource: "settings_receipt_format",
    },
  },
  {
    path: "/settings/receipt-format/company/edit/:id",
    name: "receipt-format-company-edit",
    component: () => import("@/views/setting/receipt-format/company/company-edit/companyEdit.vue"),
    meta: {
      action: "update",
      resource: "settings_receipt_format",
    },
  },
  {
    path: "/settings/prefix",
    name: "prefix",
    component: () => import("@/views/setting/prefix/prefix-edit/prefixEdit.vue"),
    meta: {
      action: "read",
      resource: "settings_prefix",
    },
  },
  // project
  {
    path: "/settings/project",
    name: "setting-project",
    component: () => import("@/views/setting/project/listTab.vue"),
    meta: {
      action: "read",
      resource: "Auth",
    },
  },

  // {
  //   path: "/settings/pdf-template/list",
  //   name: "pdf-templates-list",
  //   component: () => import("@/views/setting/pdf-template/pdf-templates-list/pdfTemplatesList.vue"),
  //   meta: {
  //     action: "read",
  //     resource: "setting_templates",
  //     // resource: "Auth",
  //   },
  // },
  {
    path: "/settings/pdf-template/edit/:id",
    name: "pdf-templates-edit",
    component: () => import("@/views/setting/receipt-format/pdf-template/pdf-template-edit/pdfTemplateEdit.vue"),
    meta: {
      action: "update",
      resource: "settings_receipt_format",
      // resource: "Auth",
    },
  },
  {
    path: "/settings/pdf-template/create",
    name: "pdf-templates-create",
    component: () => import("@/views/setting/receipt-format/pdf-template/pdf-template-edit/pdfTemplateEdit.vue"),
    meta: {
      action: "create",
      resource: "settings_receipt_format",
    },
  },

  // stamp  
  {
    path: "/settings/stamp/list",
    name: "stamps-list",
    component: () => import("@/views/setting/stamp/stamps-list/stampsList.vue"),
    meta: {
      action: "read",
      resource: "settings_stamp",
    },
  },
  {
    path: "/settings/stamp/edit/:id",
    name: "stamp-edit",
    component: () => import("@/views/setting/stamp/stamp-edit/stampEdit.vue"),
    meta: {
      action: "update",
      resource: "settings_stamp",
    },
  },
  {
    path: "/settings/stamp/create",
    name: "stamp-create",
    component: () => import("@/views/setting/stamp/stamp-edit/stampEdit.vue"),
    meta: {
      action: "create",
      resource: "settings_stamp",
    },
  },
  //invoice description
  {
    path: "/settings/invoice-description/list",
    name: "invoice-descriptions-list",
    component: () => import("@/views/setting/invoice-description/invoice-descriptions-list/invoiceDescriptionsList.vue"),
    meta: {
      action: "read",
      resource: "settings_invoice_description",
    },
  },
  // receipt document description
  {
    path: "/settings/receipt-document-description/list",
    name: "receipt-document-descriptions-list",
    component: () => import("@/views/setting/receipt-document-description/receipt-document-descriptions-list/receiptDocumentDescriptionsList.vue"),
    meta: {
      action: "read",
      resource: "settings_receipt_document_description",
    },
  },
  // quotation description
  {
    path: "/settings/quotation-description/list",
    name: "quotation-descriptions-list",
    component: () => import("@/views/setting/quotation-description/quotation-descriptions-list/quotationDescriptionsList.vue"),
    meta: {
      action: "read",
      resource: "settings_quotation_description",
    },
  },
  // receipt description   
  {
    path: "/settings/receipt-description/list",
    name: "receipt-descriptions-list",
    component: () => import("@/views/setting/receipt-description/receipt-descriptions-list/receiptDescriptionsList.vue"),
    meta: {
      action: "read",
      resource: "settings_receipt_description",
      // resource: "Auth",
    },
  },
  {
    path: "/settings/receipt-description/edit/:id",
    name: "receipt-description-edit",
    component: () => import("@/views/setting/receipt-description/receipt-description-edit/receiptDescriptionEdit.vue"),
    meta: {
      action: "update",
      resource: "settings_receipt_description",
      // resource: "Auth",
    },
  },
  {
    path: "/settings/receipt-description/create",
    name: "receipt-description-create",
    component: () => import("@/views/setting/receipt-description/receipt-description-edit/receiptDescriptionEdit.vue"),
    meta: {
      action: "create",
      resource: "settings_receipt_description",
      // resource: "Auth",
    },
  },


  {
    path: '/settings/finance-status/list',
    name: 'finance-statuses-list',
    component: () => import('@/views/setting/finance-status/listTab.vue'),
    meta: {
      action: 'read',
      resource: 'Auth'
    },
  },

  {
    path: '/settings/avatars',
    name: 'avatars-list',
    component: () => import('@/views/setting/avatar/avatars-list/avatarsList.vue'),
    meta: {
      action: 'read',
      resource: 'setting_avatar'
    },
  },

  {
    path: '/settings/announcement',
    name: 'announcement',
    component: () => import('@/views/setting/announcement/announcement-edit/announcementEdit.vue'),
    meta: {
      action: 'read',
      resource: 'settings_announcement'
    },
  },

  {
    path: '/settings/redirect-url',
    name: 'redirect-url',
    component: () => import('@/views/setting/redirect-url/redirect-url-edit/redirectUrlEdit.vue'),
    meta: {
      action: 'read',
      resource: 'settings_redirect_url'
    },
  },

  //2024-11-11 新permission

  {
    path:'/roles/list',
    name: 'roles-list',
    component:() => import('@/views/user/role/roles-list/RolesList.vue'),
    meta:{
      action: 'read',
      resource: 'setting_roles'
    }
  },
  {
    path:'/roles/edit/:id',
    name: 'roles-edit',
    component:() => import('@/views/user/role/roles-edit/RolesEdit.vue'),
    meta:{
      action: 'update',
      resource: 'setting_roles'
    }
  },
]